import { IFormValues } from './interfaces';

export const DEFAULT_VALUES: IFormValues = {
  operation: null,
  comment: '',
  wholesale_cost: '',
  quantity: '',
};
